import httpClient from './httpClient';

// Catálogo de notificações (BFF: backoffice/catalog). Cada rota exige um perfil de catálogo; o servidor decide quem pode o quê.
const base = '/backoffice/catalog';

export const listItems = async () => (await httpClient.get(`${base}/items`)).data;
export const getItem = async (itemId) => (await httpClient.get(`${base}/items/${itemId}`)).data;
export const getItemHistory = async (itemId) => (await httpClient.get(`${base}/items/${itemId}/history`)).data;

export const createItem = async ({ kind, key, content, summary }) => (await httpClient.post(`${base}/items`, { kind, key, content, summary })).data;
export const saveDraft = async (itemId, content, summary) => (await httpClient.put(`${base}/items/${itemId}/draft`, { content, summary })).data;
export const requestPublication = async (versionId) => (await httpClient.post(`${base}/versions/${versionId}/request`)).data;

export const approveVersion = async (versionId, publishAt) =>
    (await httpClient.post(`${base}/versions/${versionId}/approve`, { publishAt: publishAt || null })).data;
export const rejectVersion = async (versionId, reason) => (await httpClient.post(`${base}/versions/${versionId}/reject`, { reason })).data;
export const cancelSchedule = async (versionId) => (await httpClient.post(`${base}/versions/${versionId}/cancel-schedule`)).data;
export const revertItem = async (itemId, targetVersionId, reason) =>
    (await httpClient.post(`${base}/items/${itemId}/revert`, { targetVersionId, reason })).data;
export const deactivateItem = async (itemId, reason) => httpClient.post(`${base}/items/${itemId}/deactivate`, { reason });

// Teste do rascunho (C6): os destinos permitidos vêm da configuração do serviço; o envio usa sempre o rascunho salvo.
export const getTestTargets = async () => (await httpClient.get(`${base}/test-targets`)).data;
export const sendTest = async (versionId, channel, destination) =>
    (await httpClient.post(`${base}/versions/${versionId}/test`, { channel, destination })).data;

const ACTION_LABELS = {
    created: 'Criada',
    edited: 'Editada',
    requested: 'Publicação pedida',
    approved: 'Aprovada',
    scheduled: 'Agendada',
    rejected: 'Rejeitada',
    unscheduled: 'Agendamento cancelado',
    published: 'Publicada',
    reverted: 'Revertida',
    deactivated: 'Desativada',
    test_sent: 'Teste enviado',
    test_failed: 'Teste não enviado'
};

export const eventLabel = (action) => ACTION_LABELS[action] || action;

// Configuração do catálogo (lista de teste, intervalos, limites de tamanho). Ler: quem vê o catálogo. Gravar: editor de consentimento; a gravação leva a versão lida.
export const getSettings = async () => (await httpClient.get(`${base}/settings`)).data;
export const saveSettings = async (settings, expectedVersion) => (await httpClient.put(`${base}/settings`, { settings, expectedVersion })).data;
